import { render, staticRenderFns } from "./RejectApplication.vue?vue&type=template&id=befc4642&"
import script from "./RejectApplication.vue?vue&type=script&lang=js&"
export * from "./RejectApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports